import type { ComponentProps, ReactNode } from "react";

import { Button, type ButtonProps, Popup } from "semantic-ui-react";
import type { CSSProperties } from "styled-components";

type TooltipButtonProps = ButtonProps & {
  tooltip?: ReactNode;
  tooltipProps?: ComponentProps<typeof Popup>;
  wrapperStyle?: CSSProperties;
};

const TooltipButton = ({
  tooltip,
  tooltipProps = {},
  wrapperStyle = {},
  ...props
}: TooltipButtonProps) => {
  if (!tooltip) {
    return <Button {...props} />;
  }
  return (
    <Popup
      {...tooltipProps}
      content={tooltip}
      trigger={
        <div
          className="button"
          style={{ display: "inline-block", ...wrapperStyle }}
        >
          <Button {...props} />
        </div>
      }
    />
  );
};

export default TooltipButton;
